export default "__VITE_ASSET__BKVY6w_M__"